define(function(require) {

  var Backbone = require('backbone');

  return Backbone.Model.extend({
    urlRoot: '/delegate/civics-api/api/resources/contactidentities',
    parse: function(response) {

        return response;

    }
  });
});
